module.exports = __webpack_public_path__ + "img/foots.e5c35ac8.svg";